import { render, staticRenderFns } from "./SwitchSubscriptionToWebsite.vue?vue&type=template&id=c0c07324&scoped=true"
import script from "./SwitchSubscriptionToWebsite.vue?vue&type=script&lang=js"
export * from "./SwitchSubscriptionToWebsite.vue?vue&type=script&lang=js"
import style0 from "./SwitchSubscriptionToWebsite.vue?vue&type=style&index=0&id=c0c07324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c07324",
  null
  
)

export default component.exports